module.exports = __webpack_public_path__ + "img/jgyzs.d553c8b3.png";